export const formatCurrencyValue = (currencyValue: number): string =>
  parseFloat(currencyValue.toString()).toFixed(2);
